import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/styles.css';
import './styles/logo-spinner.css';
import App from './App';

// Disable console logs in production
if (process.env.REACT_APP_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);